export const addToCart = (id, price, description) => {
  window.gtag("event", "add_to_cart", {
    currency: "USD",
    value: price,
    items: [
      {
        item_id: id,
        item_name: description,
        price: price,
        quantity: 1,
      },
    ],
  });
};

export const onCheckout = (id, price, description) => {
  window.gtag("event", "begin_checkout", {
    currency: "USD",
    value: price,
    items: [
      {
        item_id: id,
        item_name: description,
        price: price,
        quantity: 1,
      },
    ],
  });
};

export const purchase = (id, price, description, transactionId) => {
  window.gtag("event", "purchase", {
    transaction_id: transactionId,
    currency: "USD",
    value: price,
    items: [
      {
        item_id: id,
        item_name: description,
        price: price,
        quantity: 1,
      },
    ],
  });
};
